import { useMemo } from "react";
import { useSelector } from "react-redux";
import { isPremiumAgentPlan } from "@/helpers/agentPlan";
import { getUserId, getUserType } from "@/helpers/common";
import { USER_TYPE_AGENT } from "@/constants/common";

export const TRIAL_PLAN = "Trial";

export const activePlanOf = (rows) => {
  if (!Array.isArray(rows) || rows.length === 0) return null;
  return (
    rows.find((row) => Number(row?.Is_Upcoming) === 0 && Number(row?.IsActive) === 1) ||
    rows[0]
  );
};

export const planFacts = (rows, userType) => {
  const current = activePlanOf(rows);
  const isAgent = Number(userType) === USER_TYPE_AGENT;
  const planName = current?.PlanName || null;
  return {
    loaded: Boolean(current),
    row: current,
    planName,
    onTrial: planName === TRIAL_PLAN,
    isPro: isAgent && isPremiumAgentPlan(planName),
    hasPaidPlan: isAgent && Boolean(current) && Number(rows[0]?.period) !== 1,
  };
};

let lastKnown = { userId: null, rows: null };

export const rememberedRows = (rows, userId) => {
  if (Array.isArray(rows) && rows.length > 0) {
    lastKnown = { userId, rows };
    return rows;
  }
  return userId != null && lastKnown.userId === userId ? lastKnown.rows : rows;
};

const usePlan = () => {
  const stored = useSelector((state) => state.userProfile?.userDetails);
  const userType = getUserType();
  const rows = rememberedRows(stored, getUserId());
  return useMemo(() => planFacts(rows, userType), [rows, userType]);
};

export default usePlan;
